import { Link as ChakraLink, Flex, Text } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { Link } from '#features/routing';

// Slim footer for the Discord LFG admin console. Links to the App-specific legal
// docs (`/discord-lfg-app/*`), NOT the main-site ones the global LandingFooter uses.
const DISCORD_INVITE_URL = 'https://discord.gg/zHe9vqGb7Z';

const linkStyle = {
  textStyle: 'sm',
  color: 'fg.muted',
  _hover: { color: 'fg' },
} as const;

export const DiscordAdminFooter = () => {
  const { t } = useLingui();

  return (
    <Flex
      as="footer"
      w="100%"
      maxW="1800px"
      mx="auto"
      px={{ base: 4, md: 6 }}
      py={6}
      mt={8}
      borderTop="1px solid transparent"
      style={{
        borderImage:
          'linear-gradient(90deg, transparent 0%, #5865F24D 30%, #5865F24D 70%, transparent 100%) 1',
      }}
      direction={{ base: 'column', sm: 'row' }}
      align="center"
      justify="space-between"
      gap={3}
    >
      <Text textStyle="xs" color="fg.muted">
        © {new Date().getFullYear()} Teamplay.gg
      </Text>
      <Flex gap={4} align="center" wrap="wrap" justify="center">
        <Link to="/{-$locale}/discord-lfg-app/privacy-policy" {...linkStyle}>
          {t`footer.privacyPolicy`}
        </Link>
        <Link to="/{-$locale}/discord-lfg-app/terms-and-conditions" {...linkStyle}>
          {t`footer.terms`}
        </Link>
        <ChakraLink
          href={DISCORD_INVITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          {...linkStyle}
        >
          Discord
        </ChakraLink>
      </Flex>
    </Flex>
  );
};
